/* BATTLEFIELD */
export const GET_BATTLEFIELD = 'GET_BATTLEFIELD';
export const GET_BATTLEFIELD_SUCCESS = 'GET_BATTLEFIELD_SUCCESS';
export const GET_MY_BATTLEFIELD_SUCCESS = 'GET_MY_BATTLEFIELD_SUCCESS';
export const GET_BATTLEFIELD_FAIL = 'GET_BATTLEFIELD_FAIL';

export const ADD_BATTLEFIELD = 'ADD_BATTLEFIELD';
export const ADD_BATTLEFIELD_SUCCESS = 'ADD_BATTLEFIELD_SUCCESS';
export const ADD_BATTLEFIELD_FAIL = 'ADD_BATTLEFIELD_FAIL';

export const UPDATE_BATTLEFIELD = 'UPDATE_BATTLEFIELD';
export const UPDATE_BATTLEFIELD_SUCCESS = 'UPDATE_BATTLEFIELD_SUCCESS';
export const UPDATE_BATTLEFIELD_FAIL = 'UPDATE_BATTLEFIELD_FAIL';

export const DELETE_BATTLEFIELD = 'DELETE_BATTLEFIELD';
export const DELETE_BATTLEFIELD_SUCCESS = 'DELETE_BATTLEFIELD_SUCCESS';
export const DELETE_BATTLEFIELD_FAIL = 'DELETE_BATTLEFIELD_FAIL';

export const GET_SPEC_BATTLEFIELD = 'GET_SPEC_BATTLEFIELD';
export const GET_SPEC_BATTLEFIELD_SUCCESS = 'GET_SPEC_BATTLEFIELD_SUCCESS';
export const GET_SPEC_BATTLEFIELD_FAIL = 'GET_SPEC_BATTLEFIELD_FAIL';

export const UPDATE_PERIOD = 'UPDATE_PERIOD';
export const UPDATE_PERIOD_SUCCESS = 'UPDATE_PERIOD_SUCCESS';
export const UPDATE_PERIOD_FAIL = 'UPDATE_PERIOD_FAIL';

export const SHOW_LOADING = 'SHOW_LOADING';
export const HIDE_LOADING = 'HIDE_LOADING';